const INTENT_PAGES = new Set([
  '/solutions',
  '/accompagnements',
  '/methode',
  '/a-propos',
  '/contact',
]);

function hasFbq() {
  return typeof window !== 'undefined' && typeof window.fbq === 'function';
}

export function trackMetaEvent(eventName, params = {}) {
  if (!hasFbq()) return;
  window.fbq('track', eventName, params);
}

export function trackMetaCustomEvent(eventName, params = {}) {
  if (!hasFbq()) return;
  window.fbq('trackCustom', eventName, params);
}

export function trackRoutePageView(pathname) {
  trackMetaEvent('PageView', { page_path: pathname });
}

export function trackRouteViewContent(pathname) {
  if (!INTENT_PAGES.has(pathname)) return;
  trackMetaEvent('ViewContent', {
    content_name: pathname,
    content_category: 'intent_page',
  });
}

export function isIntentPage(pathname) {
  return INTENT_PAGES.has(pathname);
}
